var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ color: _vm.style.colour })},[_c('b-icon',{attrs:{"icon":_vm.style.icon,"size":"is-small"}}),_vm._v(" "+_vm._s(_vm.style.text))],1)}
var staticRenderFns = []

export { render, staticRenderFns }